// @ts-strict-ignore
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('ItemListObjectVO')
export class ItemListObjectVO {
  @JsonProperty('articleNumber', 'string')
  public articleNumber: string = undefined;

  @JsonProperty('amount', 'number')
  public amount: number = 0;
}
